import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MtnaErrorModule, MtnaPopoverModule } from '@mtna/core-angular';

import { RdsPopoverAriaLabelPipeModule } from '../core/pipes';
import { RdsIsFormatSelectedPipe } from './is-format-selected.pipe';
import { RdsOptionPopoverConfigPipe } from './option-popover-config.pipe';
import { RdsPackagingOptionComponent } from './packaging-option.component';

const PIPES = [RdsOptionPopoverConfigPipe, RdsIsFormatSelectedPipe];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatInputModule,
    MtnaErrorModule,
    MtnaPopoverModule,
    RdsPopoverAriaLabelPipeModule,
    ReactiveFormsModule,
  ],
  declarations: [RdsPackagingOptionComponent, PIPES],
  exports: [RdsPackagingOptionComponent, PIPES],
})
export class RdsPackagingModule {}
export { RdsIsFormatSelectedPipe } from './is-format-selected.pipe';
export { RdsOptionPopoverConfigPipe } from './option-popover-config.pipe';
export * from './packaging-option.component';
